import React, { useState } from "react";
import { Card } from '@themesberg/react-bootstrap';
import MaintainedComponent from "../../../components/MaintainedComponent";
import ModuleMaintainPanel from "../../../components/ModuleMaintainPanel";

export default () => {
  const [systemRevision, setSystemRevision] = useState(0)

  return (
    <>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <h5 className="mb-1">Bảo trì toàn hệ thống</h5>
          <div className="small text-muted">Khóa toàn bộ ứng dụng khách và chặn mua mọi sản phẩm</div>
        </Card.Header>
        <Card.Body>
          <MaintainedComponent onChange={() => setSystemRevision((value) => value + 1)} />
        </Card.Body>
      </Card>

      <h5 className="mb-3">Bảo trì theo module</h5>
      <ModuleMaintainPanel refreshKey={systemRevision} />
    </>
  );
};
